'use strict';

var entityNaming = require('@bem/sdk.naming.entity.stringify');
var presets = require('@bem/sdk.naming.presets');

var stringify = entityNaming(presets.origin);

/**
 * Возвращает список классов.
 *
 * @param {string} block
 * @param {Object} mods
 * @returns {String[]}
 */
module.exports.classNamesBuilder = function (block, mods) {
    return Object.keys(mods).reduce(function (acc, key) {
        var className = stringify({
            block: block,
            mod: {
                name: key,
                val: mods[key]
            }
        });

        return acc.concat([className]);
    }, [block]);
};
